<!-- 扫码添加设备 -->
<template>
  <Dialog
    title="添加设备"
    :modelValue="modelValue"
    @onClosed="handleClosed"
    @onConfirm="handleConfirm"
    width="60%"
  >
    <template #content>
      <el-row>
        <el-col :span="20">
          <el-input
            ref="inputRef"
            autofocus
            placeholder="请输入设备编号或使用扫码枪进行扫描"
            type="textarea"
            :rows="6"
            v-model="inputData"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="3" style="padding-left: 5px">
          <el-button type="primary" @click="handleAdd">添加</el-button>
        </el-col>
      </el-row>
      <el-scrollbar height="400px" class="mt10">
        <div v-if="eqptList.length > 0">
          <span class="eqptTil">录入设备：</span>
          <template v-for="(item, index) in eqptList">
            <el-tag
              class="mr20 mt5"
              style="width: 150px"
              closable
              @close="handleTagClosed(index)"
              >{{ item.eqptCode }}
            </el-tag>
          </template>
        </div>
        <div style="margin-top: 50px" v-if="eqptErrList.length > 0">
          <span class="eqptTil">异常设备：</span>
          <template v-for="(item, index) in eqptErrList">
            <el-tag
              class="mr20 mt5"
              style="width: 150px"
              closable
              type="danger"
              @close="handleTagErrClosed(index)"
              >{{ item.eqptCode }}
            </el-tag>
          </template>
        </div>
      </el-scrollbar>
    </template>
  </Dialog>
</template>

<script setup>
import Dialog from "@/components/Element/Dialog";
import { ref, onMounted, watch, nextTick } from "vue";
import { errorMsg } from "@/utils/msgBox";
import { isNull } from "@/utils/fangerUtils";
import {
  verifyInputEqptCode,
  verifyOutputEqptCode,
  verifyOutInRecordEqptCode,
} from "@/api/warehouse/outInWarehouse";
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  inWarehouse: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Array,
    default: () => [],
  },
  canEditNum: {
    type: Number,
    default: 0,
  },
  warehouseId: {
    type: String,
    default: "",
  },
  product_id: {
    type: String,
    default: "",
  },
  applicationId: {
    type: String,
    default: "",
  },
});

const emits = defineEmits(["update:modelValue", "success"]);

const inputRef = ref(null);
const inputData = ref("");
const eqptList = ref([]);
const eqptErrList = ref([]);

const handleClosed = () => {
  emits("update:modelValue", false);
};

const handleAdd = () => {
  inputRef.value.focus();
  if (isNull(inputData.value)) return;
  const eqptCodeStrList = [
    ...new Set(inputData.value.split(/[,，\s\r\n]+/)),
  ].filter(Boolean);
  if (eqptCodeStrList.length > props.canEditNum) {
    errorMsg("添加设备数量超出");
    return;
  }
  // 调用接口
  let param = {
    productId: props.product_id,
    warehouseId: props.warehouseId,
    eqptCodes: eqptCodeStrList.join(","),
  };
  if (props.inWarehouse) {
    // 增加退货入库 调取的接口  出库申请单的id 产品id epcode
    if(props.applicationId){
      verifyOutInRecordEqptCode({
        productId: props.product_id,
        outInRecordsId: props.applicationId,
        eqptCodes: eqptCodeStrList.join(","),
      }).then(resData =>{
        resData.data.success.forEach((item) => {
            eqptList.value.push({ eqptCode: item });
          });
          resData.data.error.forEach((item) => {
            eqptErrList.value.push({ eqptCode: item });
          });
      }).catch((err) =>{
        // errorMsg(err.message);
      })
    }else{
      verifyInputEqptCode(param)
        .then((resData) => {
          resData.data.success.forEach((item) => {
            eqptList.value.push({ eqptCode: item });
          });
          resData.data.error.forEach((item) => {
            eqptErrList.value.push({ eqptCode: item });
          });
        })
        .catch((err) => {
          errorMsg(err.message);
        });
    }
  } else {
    verifyOutputEqptCode(param)
      .then((resData) => {
        resData.data.success.forEach((item) => {
          eqptList.value.push({ eqptCode: item });
        });
        resData.data.error.forEach((item) => {
          eqptErrList.value.push({ eqptCode: item });
        });
      })
      .catch((err) => {
        errorMsg(err.message);
      });
  }

  inputData.value = "";
};

const handleTagClosed = (index) => {
  eqptList.value.splice(index, 1);
  inputRef.value.focus();
};
const handleTagErrClosed = (index) => {
  eqptErrList.value.splice(index, 1);
  inputRef.value.focus();
};

const handleConfirm = () => {
  let map = new Map();
  for (let item of eqptList.value) {
    map.set(item.eqptCode, item);
  }
  if (eqptErrList.value.length > 0) {
    errorMsg("请先清除异常设备");
    return;
  }
  eqptList.value = [...map.values()];
  if (eqptList.value.length > props.canEditNum) {
    errorMsg("添加设备数量超出");
    return;
  }
  emits("success", eqptList.value);
  handleClosed();
};

onMounted(() => {
  watch(
    () => props.data,
    (newVal) => {
      eqptList.value = newVal;
    }
  );
  watch(
    () => props.modelValue,
    (newVal) => {
      if (newVal) {
        setTimeout(() => {
          inputRef.value.focus();
        }, 100);
      }
    }
  );
});
</script>

<style lang="scss" scoped>
.eqptTil {
  font-size: 20px;
  margin-right: 5px;
  margin-top: 5px;
  font-weight: bold;
}
</style>
